import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge only knows its own font-size scale, so `text-pds-*` landed in the text-COLOUR
// group and evicted `text-foreground` (PLA-1809). No `--color-pds-*` exists: `pds-` is size-only.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: [(value: string): boolean => value.startsWith("pds-")] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
